import el from "@cypherpotato/el";
import { getSafeBounds } from "./position";

export function showFlyout(...children) {
    const flyout = el("div[popover=auto].flyout", ...children, {
        onBeforeToggle(event) {
            event.target.classList.remove("visible");
        },
        onToggle(event) {
            // event.target.reposition();
            event.target.classList.add("visible");

            if (event.newState === "closed") {
                event.target.remove();
            }
        },
        mount() {
            setTimeout(() => {

            }, 100)
        },
        $functions: {
            reposition() {
                if (this.classList.contains("centered-flyout")) {
                    return;
                }

                const size = {
                    height: this.offsetHeight,
                    width: this.offsetWidth,
                };
                const { x, y } = getSafeBounds(size.width, size.height, size.width / 2 * -1, size.height / 2.5 * -1, 20);

                this.style.top = y + "px";
                this.style.left = x + "px";
            },
            dismiss() {
                closeFlyout(this);
            }
        }
    });

    document.body.appendChild(flyout);
    setTimeout(() => {
        flyout.showPopover();
        flyout.reposition();
    }, 1);

    return flyout;
}

export function closeFlyout(closestElement) {
    const flyout = closestElement.closest(".flyout");
    if (flyout) {
        flyout.classList.remove("visible");
        setTimeout(() => {
            flyout.hidePopover();
        }, 250);
    }
}